document.addEventListener('DOMContentLoaded', () => {
  const transition = document.querySelector('[data-page-transition]');
  if (transition) {
    let hasVisited = false;
    try {
      hasVisited = sessionStorage.getItem('ser-intro-seen') === '1';
      sessionStorage.setItem('ser-intro-seen', '1');
    } catch (error) {
      hasVisited = false;
    }

    const introDuration = Number(transition.dataset.introDuration || 1000);
    const navDuration = Number(transition.dataset.navDuration || 500);
    const duration = hasVisited ? navDuration : introDuration;
    if (hasVisited) transition.classList.add('is-short');
    document.documentElement.classList.add('ser-transitioning');

    window.setTimeout(() => transition.classList.add('is-leaving'), Math.max(0, duration - 220));
    window.setTimeout(() => {
      transition.classList.remove('is-active', 'is-leaving');
      document.documentElement.classList.remove('ser-transitioning');
    }, duration);
  }

  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    }));
  }

  document.querySelectorAll('.site-nav a, .brand, .footer-bottom nav a, .home-path-card, .hero-actions a, .home-cta a').forEach((link) => {
    link.addEventListener('click', () => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('http') || link.target === '_blank') return;
      try { sessionStorage.setItem('ser-intro-seen', '1'); } catch (error) { /* Continue navigation. */ }
    });
  });

  const items = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px' });
  items.forEach((item) => observer.observe(item));
});
